package com.klantenstop.web.components

import androidx.compose.runtime.Composable
import com.klantenstop.web.utils.Constants
import com.klantenstop.web.utils.Res
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A

@Composable
fun FacebookLink(modifier: Modifier = Modifier, fontSize: Int = 14) {
    A(
        href = Constants.FACEBOOK_URL,
        attrs = Modifier
            .toAttrs {
                target(ATarget.Blank)
                attr("rel", "noopener me")
            }
    ) {
        Row(
            modifier = modifier,
            horizontalArrangement = Arrangement.spacedBy(8.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Image(
                modifier = Modifier.size((fontSize + 6).px),
                src = Res.Image.facebook,
                alt = ""
            )
            SpanText(
                modifier = Modifier.fontSize(fontSize.px),
                text = "Volg ons op Facebook"
            )
        }
    }
}
